export const tansTackOptions = {
    queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 2, // 2 minutes
    },
};
